import { render, staticRenderFns } from "./ylc_release.vue?vue&type=template&id=ed60debc&"
import script from "./ylc_release.vue?vue&type=script&lang=js&"
export * from "./ylc_release.vue?vue&type=script&lang=js&"
import style0 from "./ylc_release.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports